"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useRouter_1 = require("../../contexts/useRouter/useRouter");
const string_1 = require("../../helpers/string/string");
const Tag_styled_1 = require("./Tag.styled");
const Tag = ({ className, link, text }) => {
    const { navigate } = (0, useRouter_1.useRouter)();
    return ((0, jsx_runtime_1.jsx)(Tag_styled_1.TagStyled, { className: (0, string_1.getClassName)('octo', className), onClick: (event) => { event.stopPropagation(); return link && navigate(link); }, children: (0, jsx_runtime_1.jsx)("span", { children: text }) }));
};
exports.Tag = Tag;
//# sourceMappingURL=Tag.js.map